import { createFileRoute } from '@tanstack/react-router'
import NewAmendBookingDetails from '@/components/my-booking/NewAmendBookingDetails'

export const Route = createFileRoute('/my-booking/$id/amend/confirm')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  return <NewAmendBookingDetails bookingId={bookingId} />
}
